module.exports = __webpack_public_path__ + "assets/images/CADUNFIT10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CADUNFIT10.png
// module id = 1331
// module chunks = 1